import { PathHelper } from '@sensenet/client-utils';
/**
 * Default loadItems OData options.
 */
export const defaultLoadItemsODataOptions = {
  select: ['DisplayName', 'Path', 'Id'],
  filter: "(isOf('Folder') and not isOf('SystemFolder'))",
  metadata: 'no',
  orderby: 'DisplayName'
};

/**
 * Default loadParent Odata options.
 */
export const defaultLoadParentODataOptions = {
  select: ['DisplayName', 'Path', 'Id', 'ParentId'],
  metadata: 'no'
};

/**
 *  Loads the content of the passed in parentId or gets the parent of the item prop
 * @template T
 * @param {T} item
 * @param {Repository} repository
 * @param {ODataParams<T>} [parentODataOptionsArgs]
 * @param {number} [parentId]
 * @returns the parent content
 */
async function getParent(item, repository, parentODataOptionsArgs, parentId) {
  // We don't want to query with 0
  if (parentId === 0) {
    return;
  }
  const parentODataOptions = {
    ...defaultLoadParentODataOptions,
    ...parentODataOptionsArgs
  };
  if (parentId == null && item.ParentId) {
    // We need the parent's parent
    const itemParent = await repository.load({
      idOrPath: item.ParentId,
      oDataOptions: parentODataOptions
    });
    // No need to return anything with /Root
    if (itemParent.d.ParentId === 0) {
      return;
    }
    return await repository.load({
      idOrPath: itemParent.d.ParentId,
      oDataOptions: parentODataOptions
    });
  }
  if (!parentId) {
    return;
  }
  return await repository.load({
    idOrPath: parentId,
    oDataOptions: parentODataOptions
  });
}

/**
 * Loads the picker items from the repository.
 */
export const loadItems = async ({
  path,
  loadParent = true,
  repository,
  itemsODataOptions: itemsODataOptionsArgs,
  parentODataOptions,
  parentId,
  abortController
}) => {
  const itemsODataOptions = {
    ...defaultLoadItemsODataOptions,
    ...itemsODataOptionsArgs
  };
  const itemsResult = await repository.loadCollection({
    path,
    oDataOptions: itemsODataOptions,
    requestInit: {
      signal: abortController.signal
    }
  });
  const items = itemsResult.d.results.map(item => {
    return {
      ...item,
      isParent: false
    };
  });
  if (!loadParent) {
    return items;
  }
  let parentResult;
  try {
    parentResult = await getParent(items === null || items === void 0 ? void 0 : items[0], repository, parentODataOptions, parentId !== null && parentId !== void 0 ? parentId : items !== null && items !== void 0 && items[0] ? undefined : PathHelper.getParentPath(path));
    if (!parentResult) {
      return items;
    }
  } catch {
    // Return items without parent if parent fails with error
    return items;
  }
  return [{
    ...parentResult.d,
    isParent: true
  }, ...items];
};
//# sourceMappingURL=loaders.js.map